import { useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { capitaliseFirst } from '../../../../../../utils/stringUtils';

import Dashboard from '../../../../../../layouts/Dashboard';
import { CreateCategoryItem } from '../../../../../../components/Global/CategoryItem';

import { createCategoryItemInitQuery, Category, Location } from './queries';

interface Props extends RouteComponentProps {}

interface UrlParams {
  menu_id: string;
  category_type: string;
  category_id: string;
}

const CreateItemAdmin = ({ history }: Props): React.ReactElement => {
  const { menu_id, category_type, category_id } = useParams<UrlParams>();
  const categoryType = capitaliseFirst(category_type);

  const [location, setLocation] = useState<Location>({
    name: '',
    currency: '',
    locale: '',
    tax_rate: 0,
    organisation_id: '',
  });

  const [category, setCategory] = useState<Category>({
    name: '',
    menu: {
      name: '',
    },
  });

  const { data: createCategoryItemInitData } = useQuery(createCategoryItemInitQuery(category_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && createCategoryItemInitData) {
      setCategory(createCategoryItemInitData.categories_by_pk);
      setLocation(createCategoryItemInitData.locations[0]);
    }
    return () => {
      mounted = false;
    };
  }, [createCategoryItemInitData]);

  const handleFinish = () => {
    history.push(`/loc/menus/${menu_id}/${category_type}/categories/${category_id}`);
  };

  return (
    <>
      <Dashboard
        breadcrumbs={[
          { label: 'Menus', link: `/loc/menus` },
          { label: category.menu.name, link: `/loc/menus/${menu_id}` },
          { label: `${categoryType} Categories` },
          { label: category.name, link: `/loc/menus/${menu_id}/${category_type}/categories/${category_id}` },
          { label: `Create ${capitaliseFirst(category_type)}` },
        ]}>
        {location.tax_rate && (
          <CreateCategoryItem
            category_id={category_id}
            category_type={category_type}
            organisation_id={location.organisation_id}
            currency={location.currency}
            locale={location.locale}
            taxRate={location.tax_rate}
            handleFinish={handleFinish}
          />
        )}
      </Dashboard>
    </>
  );
};

export default withRouter(CreateItemAdmin);
